'use strict';

import $ from 'jquery';

export default class AboutWidgetSquareCard {
  constructor($selector, selfInit = true) {

    if (selfInit) this.init();
  }

  init() {}
}